import * as React from 'react';
import { Link } from 'react-router-dom';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

const PageNotFound = ({
    message = 'Unfortunately, the link you followed may be broken or the page may no longer exist.'
}) => {
    return (
        <div className="error-message--container --border">
            <div className="error-message">
                <div className="error-message--header">
                    <img
                        className="error-message--header--image"
                        src={`${STATIC_STORAGE_URL}/img/404-ghost.png`}
                    />
                    <div className="error-message--header--title">
                        Sorry, page not found.
                    </div>
                </div>
                <div className="error-message--body">{message}</div>
                <div className="error-message--actions">
                    <Link
                        className="error-message--actions--button --blue"
                        to="/"
                    >
                        Go to home
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default PageNotFound;
